module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Design/Cap-3-ae292f337fe1c4307d6ad0994fbf527f.svg";